import React from 'react';
import './GlassCard.css';

export default function GlassCard({
  children,
  className = '',
  size = 'md',
  interactive = false,
  glow = false,
  as: Tag = 'div',
  ...props
}) {
  const classes = [
    'glass-card',
    `glass-card--${size}`,
    interactive ? 'glass-card--interactive' : '',
    glow ? 'glass-card--glow' : '',
    className,
  ].filter(Boolean).join(' ');

  return <Tag className={classes} {...props}>{children}</Tag>;
}
